import { Router } from '@angular/router';
import { RoomPolicyModel, RoomPolicyRequest, RoomPolicyMaster, RoomPolicyAuthentication, RoomPolicySubAgent, RoomPolicyRequestDetails, RoomPolicyFilter, CancellationPolicy, RoomPolicyRoomDetails, RoomPolicyHotelRoom } from '../../Model/PolicyModel';
import { HotelService } from '../../Service/hotel.service';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { HotelFeatureModel, HotelFeatureRequest, HotelFeatureMaster, HotelFeatureAuthentication, HotelFeatureSubAgent, HotelFeatureRequestDetails, HotelFeatureFilter } from '../../Model/HotelFeatureModel';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NavigationService } from '../../Service/navigation.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { OwlOptions } from 'owl.carousel';
import { CompanySettingService } from '../../Service/company-setting.service';
import { SharedServiceService } from '../../Service/shared-service.service';
import { Meta, Title } from '@angular/platform-browser';
import { MetaService } from '../../Service/meta.service';
import { debug } from 'util';

declare var google: any; // Declare Google to avoid "not defined" error

@Component({
  selector: 'app-hotel-detail',
  templateUrl: './hotel-detail.component.html',
  styleUrls: ['./hotel-detail.component.css']
})
export class HotelDetailComponent implements OnInit {
  seoData: any;  // Holds the SEO data
  loader: boolean;
  waitingloader: boolean = true;
  showResult: boolean;
  showFeature: boolean;
  hotelDetails: any;
  allhoteldata: any;
  hotelSearchRequest: any;
  hotelFeatureModel: HotelFeatureModel;
  hotelFeature: any;
  roomPolicy: RoomPolicyModel;
  CancellationPolicy: any;
  preBookRQ: RoomPolicyModel;
  similarHotels: any;
  Images: any[];
  groupedRooms: { [key: string]: any[] } = {};
  SlideOptions = { items: 1, dots: true, nav: true };
  CarouselOptions = { items: 3, dots: true, nav: true };
  modalRef: BsModalRef;
  HotelId: string = '';
  RoomRquest: any;
  CompanySetting = CompanySettingService;
  ImageMainShow: OwlOptions = {
    items: 1,
    dots: true,
    loop: true,
    navigation: true,
    dotsData: true,
    autoplay: true,
    autoplayTimeout: 2000,  // Slide switches every 2 seconds
    autoplaySpeed: 800,     // Transition animation speed
    pagination: true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      980: {
        items: 1
      },
      1199: {
        items: 1
      }
    },
    nav: true
  }

  similarHtlOptions: OwlOptions = {
    items: 4,
    dots: true,
    loop: true,
    navigation: true,
    autoplay: true,
    autoplayHoverPause: true,
    autoplayTimeout: 3000,  // Slide switches every 2 seconds
    autoplaySpeed: 800,
    pagination: true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      980: {
        items: 2
      },
      1199: {
        items: 4
      }
    },
    nav: true
  }
  constructor(
    private location: Location,
    private metaServiceData: MetaService,
    private title: Title, private meta: Meta,
    private _hotelService: HotelService, private modalService: BsModalService
    , private route: Router, private _navigation: NavigationService,private toastr: ToastrService,public sharedServiceService:SharedServiceService) {
    this._navigation.ChangeSelection('hotel');
    this.sharedServiceService.isShownCurrency=true;
  }

  ngOnInit() {
    this.seoData = this.metaServiceData.getSeo("Hotel-detail"," ");
    this.updateMetaTags();
    this.Images = [];
    this.Images.push("/assets/images/hotel/not_available.jpg");
    var roomRquest = sessionStorage.getItem("getRoomRquest");
    this.loadGoogleMaps();

    this.sharedServiceService.currencySymbol=JSON.parse(sessionStorage.getItem("currencySymbals"));
    this.sharedServiceService.currencyConversionRate=JSON.parse(sessionStorage.getItem("currencyConversionRate"));
    this.sharedServiceService.selectedCurrency = JSON.parse(sessionStorage.getItem("selectedCurrency"));
    debugger;
    
    
    if (roomRquest != null && roomRquest != undefined) {
      this.RoomRquest = JSON.parse(roomRquest);
      this.HotelId = this.RoomRquest.Request.RequestDetails.Filter.HotelId;
      this.similarHotels = JSON.parse(sessionStorage.getItem("similarHotels"));
      if (this.similarHotels != null && this.similarHotels.length > 1) {
        this.similarHotels = this.similarHotels.filter(product => product.HotelId != this.HotelId);
      }
      // var dtt = new Date();
     // console.log('ready for called getHotelFreatures:--' + dtt);
      this.getHotelFreatures();
     // dtt = new Date();
     // console.log('called getHotelFreatures:--' + dtt);
      this._hotelService.GetRooms(this.RoomRquest).subscribe(data => {
       // dtt = new Date();
       // console.log('Get room response:--' + dtt);
        this.allhoteldata = data as any;
        if (this.allhoteldata.Response.ResponseDetails.GetRoom) {
          this.hotelDetails = this.allhoteldata.Response.ResponseDetails.GetRoom.Hotels.Hotel[0];
          this.groupedRooms = this.groupAndSortRoomsByType(this.hotelDetails.Rooms.Room);
          debugger;
        }
        this.hotelSearchRequest = this.allhoteldata.Response.Master;
        this.showResult = true;
        this.waitingloader = false;
       // this.getHotelFreatures();
      }, error => { console.log(error); this.waitingloader = false; })
    }
    else {
      this.route.navigate(['/hotel']);
    }
  }

  groupAndSortRoomsByType(rooms: any[]): { [key: string]: any[] } {
    return rooms.reduce((acc, room) => {
      const key = room.Type;

      if (!acc[key]) {
        acc[key] = [];
      }

      acc[key].push(room);

      // Sort each group after pushing
      acc[key].sort((a, b) => a.GrossPrice - b.GrossPrice); // Ascending
      // Use `b.GrossPrice - a.GrossPrice` for Descending

      return acc;
    }, {} as { [key: string]: any[] });
  }


  getHotelFreatures() {
   //var dtt = new Date();
   //console.log('in feature:--' + dtt);
    this.hotelFeatureModel = new HotelFeatureModel();
    this.hotelFeatureModel.HotelFeatureRequest = new HotelFeatureRequest();
    this.hotelFeatureModel.HotelFeatureRequest.Master = new HotelFeatureMaster();
    this.hotelFeatureModel.HotelFeatureRequest.Authentication = new HotelFeatureAuthentication();
    this.hotelFeatureModel.HotelFeatureRequest.Authentication.SubAgent = new HotelFeatureSubAgent();
    this.hotelFeatureModel.HotelFeatureRequest.RequestDetails = new HotelFeatureRequestDetails();
    this.hotelFeatureModel.HotelFeatureRequest.RequestDetails.Filter = new HotelFeatureFilter();
    this.hotelFeatureModel.HotelFeatureRequest.RequestDetails.Filter = this.RoomRquest.Request.RequestDetails.Filter;

    this.hotelFeatureModel.HotelFeatureRequest.Master = this.RoomRquest.Request.Master;
    this.hotelFeatureModel.HotelFeatureRequest.Authentication = this.RoomRquest.Request.Authentication;

    this._hotelService.GetHotelFeature(this.hotelFeatureModel).subscribe(data => {
     // dtt = new Date();
    //  console.log('feature response completed:--' + dtt);
      var allData = data as any;
      this.hotelFeature = allData.HotelFeatureResponse.HotelDetails;
      debugger;
      if (this.hotelFeature != null)
      {
      this.hotelFeature.Description=this.hotelFeature!=null?this.hotelFeature.Description.split("&lt;").join("<").split("&gt;").join(">"):"";
      }
      this.showFeature = true;

      if (this.hotelFeature != null && this.hotelFeature.Images != null) {
        this.Images = [];
        this.hotelFeature.Images.Image.forEach(element => {
          this.Images.push(element.Big);

        });
      }
      else if(this.hotelDetails!=null && this.hotelDetails.Image!=null)
      {
        this.Images = [];
        this.Images.push(this.hotelDetails.Image);
      }
      if(this.Images!=null && this.Images.length==2)
      {
        if(this.hotelDetails!=null && this.hotelDetails.Image!=null)
         {
           this.Images.push(this.hotelDetails.Image);
         }
         else
         {
          this.Images.push('assets/images/hotel/hotel-01.jpg');
        }
      }
    });
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }
  scrollById(id) {
    let el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
  MainImageGallery(template: TemplateRef<any>){
    if (this.modalRef != undefined)
      this.modalRef.hide();
      this.modalRef = this.modalService.show(template, { class: 'modal-dialog-width' });
  }
  getCancellationPolicy(HotelId, roomID, token, template: TemplateRef<any>, Provider) {
    if (this.modalRef != undefined)
      this.modalRef.hide();
    this.roomPolicy = new RoomPolicyModel();
    this.roomPolicy.Request = new RoomPolicyRequest();
    this.roomPolicy.Request.Master = new RoomPolicyMaster();
    this.roomPolicy.Request.Authentication = new RoomPolicyAuthentication();
    this.roomPolicy.Request.Authentication.SubAgent = new RoomPolicySubAgent();
    this.roomPolicy.Request.RequestDetails = new RoomPolicyRequestDetails();
    this.roomPolicy.Request.RequestDetails.Filter = new RoomPolicyFilter();
    this.roomPolicy.Request.RequestDetails.CancellationPolicy = new CancellationPolicy();
    this.roomPolicy.Request.RequestDetails.CancellationPolicy.Rooms = new RoomPolicyRoomDetails();
    this.roomPolicy.Request.RequestDetails.CancellationPolicy.Rooms.Room = new Array<RoomPolicyHotelRoom>();


    this.roomPolicy.Request.Master = this.allhoteldata.Response.Master;
    this.roomPolicy.Request.Authentication = this.allhoteldata.Response.Authentication;
    var roomRquest = sessionStorage.getItem("getRoomRquest");
    var RQ = JSON.parse(roomRquest);
    this.roomPolicy.Request.RequestDetails.Filter.HotelId = HotelId;
    this.roomPolicy.Request.RequestDetails.Filter.RoomId = roomID;
    this.roomPolicy.Request.RequestDetails.Filter.Token = token;
    this.roomPolicy.Request.RequestDetails.Filter.Provider = Provider;
    this.roomPolicy.Request.RequestDetails.CancellationPolicy = RQ.Request.RequestDetails.GetRoom;
    this.loader = true;
    this._hotelService.GetRoomCancellationPolicy(this.roomPolicy).subscribe(data => {
      var alldata = data as any;
      if (alldata && alldata.Response && alldata.Response.ResponseDetails && alldata.Response.ResponseDetails.CancellationPolicy) {
        this.CancellationPolicy = alldata.Response.ResponseDetails.CancellationPolicy;        
      }
      this.modalRef = this.modalService.show(template);
      this.loader = false;
    }, err => {
      this.loader = false;
    });
  }
  GetHotelRoom(HotelID: any, Token: any, Provider: any) {
    debugger;
    this.loader = true;
    var hotelsRoom = JSON.parse(sessionStorage.getItem("getRoomRquest"));
    hotelsRoom.Request.RequestDetails.Filter.HotelId = HotelID;
    hotelsRoom.Request.RequestDetails.Filter.Token = Token;
    hotelsRoom.Request.RequestDetails.Filter.Provider = Provider;

    sessionStorage.setItem("getRoomRquest", JSON.stringify(hotelsRoom));

    window.open("/hotel-detail", '_self');
    this.loader = false;
  }
  goBack() {
    if (window.history.length > 1)
    {
    this.location.back();
    }
    else {
    this.route.navigate(['/Hotel']);
  }
  }


  bookHotel(HotelId, roomID, token, Provider) {
    this.loader = true;
    if (this.modalRef != undefined)
      this.modalRef.hide();

      this.roomPolicy = new RoomPolicyModel();
      this.roomPolicy.Request = new RoomPolicyRequest();
      this.roomPolicy.Request.Master = new RoomPolicyMaster();
      this.roomPolicy.Request.Authentication = new RoomPolicyAuthentication();
      this.roomPolicy.Request.Authentication.SubAgent = new RoomPolicySubAgent();
      this.roomPolicy.Request.RequestDetails = new RoomPolicyRequestDetails();
      this.roomPolicy.Request.RequestDetails.Filter = new RoomPolicyFilter();
      this.roomPolicy.Request.RequestDetails.CancellationPolicy = new CancellationPolicy();
      this.roomPolicy.Request.RequestDetails.CancellationPolicy.Rooms = new RoomPolicyRoomDetails();
      this.roomPolicy.Request.RequestDetails.CancellationPolicy.Rooms.Room = new Array<RoomPolicyHotelRoom>();
  
  
      this.roomPolicy.Request.Master = this.allhoteldata.Response.Master;
      this.roomPolicy.Request.Authentication = this.allhoteldata.Response.Authentication;
      var roomRquest = sessionStorage.getItem("getRoomRquest");
      var RQ = JSON.parse(roomRquest);
      this.roomPolicy.Request.RequestDetails.Filter.HotelId = HotelId;
      this.roomPolicy.Request.RequestDetails.Filter.RoomId = roomID;
      this.roomPolicy.Request.RequestDetails.Filter.Token = token;
      this.roomPolicy.Request.RequestDetails.Filter.Provider = Provider;
      this.roomPolicy.Request.RequestDetails.CancellationPolicy = RQ.Request.RequestDetails.GetRoom;
      this.loader = true;
      this._hotelService.GetRoomCancellationPolicy(this.roomPolicy).subscribe(data => {
        var alldata = data as any;
        if (alldata && alldata.Response && alldata.Response.ResponseDetails && alldata.Response.ResponseDetails.CancellationPolicy) {
          this.CancellationPolicy = alldata.Response.ResponseDetails.CancellationPolicy;
          this.preBookRQ = new RoomPolicyModel();
          this.preBookRQ.Request = new RoomPolicyRequest();
          this.preBookRQ.Request.Master = new RoomPolicyMaster();
          this.preBookRQ.Request.Authentication = new RoomPolicyAuthentication();
          this.preBookRQ.Request.Authentication.SubAgent = new RoomPolicySubAgent();
          this.preBookRQ.Request.RequestDetails = new RoomPolicyRequestDetails();
          this.preBookRQ.Request.RequestDetails.Filter = new RoomPolicyFilter();
          this.preBookRQ.Request.RequestDetails.PreBook = new CancellationPolicy();
          this.preBookRQ.Request.RequestDetails.PreBook.Rooms = new RoomPolicyRoomDetails();
          this.preBookRQ.Request.RequestDetails.PreBook.Rooms.Room = new Array<RoomPolicyHotelRoom>();


          this.preBookRQ.Request.Master = this.allhoteldata.Response.Master;
          this.preBookRQ.Request.Authentication = this.allhoteldata.Response.Authentication;
          var roomRquest = sessionStorage.getItem("getRoomRquest");
          var RQ = JSON.parse(roomRquest);
          this.preBookRQ.Request.RequestDetails.Filter.HotelId = HotelId;
          this.preBookRQ.Request.RequestDetails.Filter.RoomId = roomID;
          this.preBookRQ.Request.RequestDetails.Filter.Token = token;
          this.preBookRQ.Request.RequestDetails.Filter.Provider = Provider;
          this.preBookRQ.Request.RequestDetails.PreBook = RQ.Request.RequestDetails.GetRoom;

          this._hotelService.PreBook(this.preBookRQ).subscribe(data => {
            var allData = data as any;
            if (allData != null && allData.Response != null && allData.Response.ResponseDetails.PreBook != null && allData.Response.ResponseDetails.PreBook.IsBookable.Status) {
              var selectedRoom = this.hotelDetails.Rooms.Room.find(data => {
                return data.RoomId == roomID;
              });
              if (selectedRoom) {
                try {
                  if (this.allhoteldata.Response.ResponseDetails.GetRoom.Hotels.Hotel[0].Image == '' || this.allhoteldata.Response.ResponseDetails.GetRoom.Hotels.Hotel[0].Image == null) {
                    if (this.Images.length > 0) {
                      this.allhoteldata.Response.ResponseDetails.GetRoom.Hotels.Hotel[0].Image = this.Images[0];
                    }
                  }
                } catch (e) {

                }
                selectedRoom.CancellationPolicy = this.CancellationPolicy;
                sessionStorage.setItem("PreBookRQ", JSON.stringify(this.preBookRQ));
                sessionStorage.setItem("SelectedRoom", JSON.stringify(selectedRoom));
                sessionStorage.setItem("HotelDetailsRS", JSON.stringify(this.allhoteldata));
                this.route.navigate(['/hotel-book']);
              }
              else {
                this.toastr.warning('Sorry! This Room is not bookable.');
                this.loader = false;
              }
            }
            else {
              this.toastr.warning('Sorry! This Room is not bookable.');
              this.loader = false;
            }
          }, error => {
            this.toastr.warning('Sorry! This Room is not bookable.');
            this.loader = false;
          });
        }
        else {
          this.toastr.warning('Sorry! This Room is not bookable.');
          this.loader = false;
        }

      }, err => {
        this.toastr.warning('Sorry! This Room is not bookable.');
          this.loader = false;
      });
  }
  trackByFn(index: number, item: any) {
    return index; // or item.id
  }
  slider_for = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav',
    autoplay: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: true,

        }
      }]
  };
  slider_nav = {
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    arrows: true,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          margin: 10

        }
      }]
  };
  updateMetaTags() {
    if (this.seoData) {
      this.title.setTitle(this.seoData.Title);
      this.meta.updateTag({ name: 'description', content: this.seoData.metaDescription });
      this.meta.updateTag({ name: 'keywords', content: this.seoData.metaKeyword });
    }
  }
    
  

  loadGoogleMaps() {
    if (window['google']) {
      this.initMap();
    } else {
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCMYaeUEnV-BT1Os4NFi0XuJgOsXfp-umw&libraries=places';
      //script.src = 'https://maps.googleapis.com/maps/api/js?v=3.24&key=AIzaSyBZD_81a4kYRc_lAcJpxIYX4dwzI8O583g&amp;libraries=places&amp;sensor=true';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.initMap();
      };
      document.body.appendChild(script);
    }
  }

  initMap() {
    console.log("Initializing Map...");
    const map = new google.maps.Map(document.getElementById("map") as HTMLElement, {
      center: { lat: 28.633801, lng: 77.220299 },
      zoom: 15
    });

    const marker = new google.maps.Marker({
      position: { lat: 28.633801, lng: 77.220299 },
      map: map
    });

    console.log("Marker added:", marker);
  }

}
